import validator from '@/sui/components/sheet/validate/impl/validator'
import rand from '@/sui/tools/rand'
import units from '@/sui/data/units'
import denominators from '@/sui/data/denominators'
import assert from '@/sui/tools/assert'
import moment from 'moment'

function buildMessage (module) {
  return `Merci d'avoir envoyé vos fiches, votre participation
au volet ${module} est validée.`
}

const messages = {
  observa4: buildMessage('OBSERVA4'),
  spy4: buildMessage('SPY4'),
  badiCause: buildMessage('BADICAUSE')
}

const steps = [
  validator.steps.validate(vm => vm.periodSheets),
  validator.steps.statuses(vm => vm.module),
  {
    title: 'Envoi de la liste des fiches',
    timeout: 10000,
    error: null,
    promise: true,
    progress: {
      value: 100
    },

    run: function (vm, data, iteration) {
      if (data.result.length > 0) {
        return new Promise(function (resolve) {
          setTimeout(function () {
            resolve()
          }, 0)
        }).then(
          () => {
            return {
              end: true,
              success: false,
              error: `Impossible de mettre à jour la liste des fiches car
${data.result.length} fiche.s contienne.nt des erreurs. Merci de les corriger
avant de réessayer.`
            }
          }
        )
      }
      const valid = []
      const reducer = (result, f) => {
        result.push({ id: f.id, ver: f.v })
        return result
      }
      data.valid.reduce(reducer, valid)

      let msg = messages[vm.module]
      if (msg == null) {
        msg = `Il vous faut maintenant renseigner (ou confirmer)
les dénominateurs.`
      }

      return vm.$store.dispatch(
        'surveillances/updateDatasetSheets',
        {
          name: vm.fields.name.value,
          mod: vm.module,
          shts: valid,
          surv: vm.surveillance.id,
          year: vm.surveillance.year
        }
      ).then(
        r => {
          if (r.data.err != null) {
            return {
              end: true,
              success: false,
              error: `${validator.msg.data}, ${validator.msg.verify}.
${validator.msg.persist}`
            }
          } else {
            vm.$notify(
              {
                type: 'success',
                title: 'Validation des fiches réussie !',
                content: msg,
                duration: 4000
              }
            )
          }

          return {
            end: true,
            success: true
          }
        }
      )
    },

    setError: function () {
      this.error = `${validator.msg.data}, ${validator.msg.verify}.
${validator.msg.persist}`
    }
  }
]

function compareSheets (f, s) {
  if (f.id < s.id) {
    return -1
  }

  if (f.id > s.id) {
    return 1
  }

  return 0
}

function versionDiff (ds, ps) {
  const svl = ds.slice().sort(compareSheets)
  const sl = ps.slice().sort(compareSheets)

  const result = { v: [], a: [], d: [] }

  let svi = 0
  let si = 0

  while (si !== sl.length && svi !== svl.length) {
    const cs = sl[si]
    const csv = svl[svi]

    if (csv.id === cs.id) {
      if (csv.v !== cs.v) {
        result.v.push(csv.id)
      }
      ++svi
      ++si
    } else if (csv.id < cs.id) {
      result.d.push(csv.id)
      ++svi
    } else {
      result.a.push(cs.id)
      ++si
    }
  }

  if (si < sl.length) {
    for (let i = si; i !== sl.length; ++i) {
      result.a.push(sl[i].id)
    }
  } else if (svi < svl.length) {
    for (let i = svi; i !== svl.length; ++i) {
      result.d.push(svl[i].id)
    }
  }

  result.diffCount = result.v.length + result.a.length + result.d.length
  return result
}

function setChecker (target, pl) {
  const t = target.type
  if (t === 2 || t === 3) {
    return
  }

  const excluded = [
    18, 19, 40, 45, 54, 64, 69, 71, 1002, 1102, 1106
  ]
  if (excluded.indexOf(target.unitType) !== -1) {
    return
  }

  function test (t) {
    return t == null || t === '-1' || t === '0'
  }

  target.checker = (d) => {
    if (test(d.bed)) {
      return null
    }

    if (!test(d.jh) && (d.jh / (pl * d.bed) > 1)) {
      return {
        type: 'warning',
        text: `Attention : le nombre de journées d'hospitalisation semble élevé.`
      }
    }

    if (!test(d.adm) && (d.adm / (pl * d.bed) > 0.3)) {
      return {
        type: 'warning',
        text: `Attention : le nombre d'admissions semble élevé.`
      }
    }

    return null
  }
}

function setColumns (year, target, title) {
  const result = []

  if (title) {
    const label = target.subtitle
      ? `${target.code}<br><small>(${target.subtitle})</small>` : target.code
    result.push(
      {
        key: 'ut',
        title: `Type d'unité`,
        value: label,
        ign: true
      }
    )
  }

  const uf = target.uf
  if (uf !== '__all__') {
    result.push({ key: 'uf', title: 'UF', value: uf, ign: true })
  }

  const denominatorsConfig = denominators.getDenominatorsAndType(year, target.unitType)
  result.push(...denominatorsConfig.denominators)

  target.columns = result
  target.type = denominatorsConfig.type
  const td = target.denominators
  for (let i = 0; i !== result.length; ++i) {
    const col = result[i]
    if (!col.ign && td[col.key] == null) {
      td[col.key] = ''
    }
  }
}

//  year, list, denominators, id, disc, pl, headCol
function addUnitToList (
  year, keys, result, denominators, uf, ut, pl
) {
  const key = `${uf}${ut}`
  if (keys.indexOf(key) !== -1) {
    return
  }

  const den = extractDenominators(denominators, uf, ut)
  const disc = units[year].discFromIndex(ut)
  const code = units[year].codeFromIndex(ut)

  const target = {
    uf: uf,
    unitType: ut,
    denominators: den,
    code: code,
    id: disc.id,
    disc: disc
  }
  setColumns(year, target, true)
  setChecker(target, pl)

  result.push(target)
  keys.push(key)
}

function extractDenominators (denominators, uf, ut) {
  const predicate = d => d.ut === ut && d.uf === uf && d.den !== 'kt'
  let result = denominators.edit.find(predicate)
  if (result == null) {
    result = {
      ut: ut,
      uf: uf,
      value: {}
    }
    denominators.edit.push(result)
  }

  if (denominators.remote != null) {
    const list = denominators.remote.filter(predicate)
    list.forEach(l => {
      if (result.value[l.den] == null) {
        result.value[l.den] = `${l.val}`
      }
    })
  }

  return result.value
}

function compareUnits (f, s) {
  if (f.unitType === s.unitType) {
    return f.uf.localeCompare(s.uf)
  }

  return s.disc.sortIndex - f.disc.sortIndex
}

function mainPeriodLength (periods) {
  let result = 0
  periods.forEach(
    p => {
      assert.equals(p.unit, '')
      result += p.end.diff(p.start, 'days')
    }
  )
  return result
}

function periodLength (uf, ut, periods) {
  if (periods.length === 0) {
    return 0
  }

  if (periods[0].unit === '') {
    return mainPeriodLength(periods)
  }

  const key = `${ut}.${uf}`
  let ufc = 0
  for (let i in periods) {
    const p = periods[i]
    if (p.unit === key) {
      ufc += p.end.diff(p.start, 'days')
    }
  }

  assert(ufc > 0)
  return ufc
}

function extractUnitList (
  year, sheets, denominators, surveillance, module, periods
) {
  const result = []
  const keys = []
  let headers = true

  if (module === 'bactADI') {
    sheets.forEach(
      s => {
        const uf = s.f.uf
        const ut = s.f.unitType
        const pl = periodLength(uf, ut, periods)
        addUnitToList(year, keys, result, denominators, uf, ut, pl)
      }
    )
  } else {
    const list = surveillance.modules[module].ufs
    list.forEach(
      s => {
        const pl = periodLength(s.name, s.ufType, periods)
        addUnitToList(year, keys, result, denominators, s.name, s.ufType, pl)
      }
    )
  }

  if (module === 'expADI') {
    headers = null
    result.forEach(
      r => {
        r.expDenominators = {}
        for (let k in r.denominators) {
          if (r.columns.find(c => c.key === k) == null) {
            r.expDenominators[k] = r.denominators[k]
            delete r.denominators[k]
          }
        }
      }
    )
  }

  result.sort(compareUnits)
  setHeaders(result, headers)
  return result
}

function setHeaders (result, hd) {
  let type = 0
  result.forEach(
    r => {
      if (hd === null) {
        if (r.type !== type) {
          r.header = true
          type = r.type
        } else {
          r.header = false
        }
      } else {
        r.header = hd
      }
    }
  )
}

function addDiscToList (
  year, list, denominators, id, disc, pl, headCol
) {
  const uf = '__all__'
  const code = disc.code
  const den = extractDenominators(denominators, uf, disc.index)
  const speOptional = disc.optional

  const target = {
    uf: uf,
    unitType: disc.index,
    denominators: den,
    code: code,
    subtitle: disc.subtitle,
    id: id,
    disc: disc,
    optional: speOptional
  }

  setColumns(year, target, headCol)
  setChecker(target, pl)

  list.push(target)
}

function hasBacteriemia (vm, unitType) {
  return vm.unitList.find(
    (spe) => spe.unitType === unitType
  ) != null
}

function extractDiscList (vm, edit) {
  const denominators = {
    remote: vm.dsDenominators,
    edit: edit
  }

  const pl = mainPeriodLength(vm.periods)
  const year = vm.surveillance.year

  const uy = units[vm.surveillance.year]
  const withoutBact = []
  const withBact = []
  const withoutBactOpt = {}
  const withBactOpt = {}

  for (let key in uy.disc) {
    const disc = uy.disc[key]

    const optTarget = []
    if (disc.optionals && disc.optionals.length > 0) {
      for (let i = 0; i !== disc.optionals.length; ++i) {
        const spe = disc.optionals[i]
        addDiscToList(
          year, optTarget, denominators, disc.id, spe, pl, true
        )
      }
      if (optTarget.length > 0) {
        optTarget.sort(compareUnits)
      }
    }

    if (disc.expands == null || disc.expands.length === 0) {
      let target = withoutBact
      let header = true
      for (let i = 0; i !== disc.list.length; ++i) {
        const spe = disc.list[i]
        if (hasBacteriemia(vm, spe.index)) {
          target = withBact
          header = false
          break
        }
      }

      addDiscToList(
        year, target, denominators, disc.id, disc, pl, header
      )

      if (optTarget.length > 0) {
        if (header) {
          withoutBactOpt[disc.code] = optTarget
        } else {
          withBactOpt[disc.code] = optTarget
        }
      }

      continue
    }

    let baseHasBacteremia = false
    let base = false
    for (let i = 0; i !== disc.list.length; ++i) {
      const spe = disc.list[i]
      const exp = disc.expands.find(
        e => e.code === spe.code
      )
      const hb = hasBacteriemia(vm, spe.index)
      if (!exp) {
        baseHasBacteremia = baseHasBacteremia || hb
        base = true
        continue
      }

      let target = hb ? withBact : withoutBact
      let header = !hb
      addDiscToList(
        year, target, denominators, disc.id, exp, pl, header
      )
    }

    if (base) {
      let baseTarget = baseHasBacteremia ? withBact : withoutBact
      let baseHeader = !baseHasBacteremia
      addDiscToList(
        year, baseTarget, denominators, disc.id, disc, pl, baseHeader
      )

      if (optTarget.length > 0) {
        if (!baseHasBacteremia) {
          withoutBactOpt[disc.code] = optTarget
        } else {
          withBactOpt[disc.code] = optTarget
        }
      }
    }
  }

  const empty = []
  vm.emptyDiscList.forEach(
    u => {
      addDiscToList(
        year, empty, denominators, u.id, u.disc, pl, true
      )
    }
  )
  const result = {
    list: withBact,
    optionals: withBactOpt,
    empty: empty,
    missing: withoutBact,
    emptyOptionals: withoutBactOpt
  }

  result.list.sort(compareUnits)
  result.missing.sort(compareUnits)
  result.empty.sort(compareUnits)
  setHeaders(result.list, true)
  setHeaders(result.empty, null)

  return result
}

function getDenominators (u, list, result) {
  for (let d in list) {
    const v = list[d]
    if (v == null || v === '') {
      return false
    }

    result.push(
      {
        'uf': u.uf,
        'ut': u.unitType,
        'den': d,
        'disc': u.id,
        'val': parseInt(v)
      }
    )
  }

  return true
}

function listDenominators (list, result, expADI) {
  for (let i in list) {
    const u = list[i]

    if (!getDenominators(u, u.denominators, result) && !u.optional) {
      return false
    }

    if (expADI && !getDenominators(u, u.expDenominators, result)) {
      return false
    }
  }
  return true
}

function prepareUfList (listBySpe) {
  const result = {}
  const keys = Object.keys(listBySpe)
  for (let i = 0; i !== keys.length; ++i) {
    const key = keys[i]
    const list = listBySpe[key]
    const sl = []
    for (let j = 0; j !== list.length; ++j) {
      const elt = list[j]
      if (elt.selected) {
        sl.push(elt.unit)
      }
    }
    sl.sort(compareUnits)
    setHeaders(sl, null)
    result[key] = sl
  }

  return result
}

function datasetRecap (vm) {
  const t = (t) => {
    const icon = t ? 'ok' : 'remove'
    const text = t ? 'success' : 'danger'
    return `glyphicon glyphicon-${icon} text-${text}`
  }

  const tt = vm.target != null
  const result = [
    {
      label: `Choix de la période de surveillance`,
      shortLabel: 'Période choisie',
      valid: tt,
      classes: t(tt)
    },
    {
      label: `Fiches validées et envoyées`,
      shortLabel: 'Fiches envoyées',
      valid: tt && vm.target.step >= 1,
      classes: t(tt && vm.target.step >= 1)
    },
    {
      label: `Dénominateurs saisis et confirmés`,
      shortLabel: 'Dénominateurs saisis',
      valid: tt && vm.target.step >= 2,
      classes: t(tt && vm.target.step >= 2)
    }
  ]

  return result
}

function makePeriodSheetsList (year, list, module) {
  const result = []
  list.forEach(
    s => {
      const obj = {
        sheetNumber: parseInt(s.f.sheetNumber),
        unitType: units[year].codeFromIndex(s.f.unitType),
        uf: s.f.uf
      }

      if (module.format != null) {
        obj.type = module.format.obsManagment(s.f.obsManagment)
      }
      result.push(obj)
    }
  )
  result.sort(
    (f, s) => f.sheetNumber - s.sheetNumber
  )
  return result
}

function toServerPeriods (list) {
  const result = []
  list.forEach(
    p => {
      const d = (d, h) => moment(d).add(h, 'hour')
      result.push(
        {
          unit: p.value.unit,
          start: d(p.value.date.start, 4),
          end: d(p.value.date.end, 16)
        }
      )
      if (p.value.twoPeriods) {
        result.push(
          {
            unit: p.value.unit,
            start: d(p.value.date2.start, 4),
            end: d(p.value.date2.end, 16)
          }
        )
      }
    }
  )

  return result
}

function extractUfList (year, list, discs, selectedList) {
  const result = {}
  for (let i in list) {
    const u = list[i]
    if (u.uf == null || u.uf === '') {
      continue
    }

    const selected = selectedList.find(
      s => s.uf === u.uf && s.ut === u.unitType
    )

    let target = discs.find(s => u.code === s.code)
    if (target == null) {
      target = discs.find(s => u.disc.index === s.disc.index)
    }

    const unit = {
      selected: selected != null,
      unit: u
    }

    if (result[target.code] == null) {
      result[target.code] = [unit]
    } else {
      result[target.code].push(unit)
    }
  }
  return result
}

function formatDate (d) {
  return moment(d).format('YYYY-MM-DD')
}

function buildPeriod (y, p, u) {
  const p0 = p[0]
  const pr = {
    twoPeriods: false,
    unit: u,
    date: { start: formatDate(p0.start), end: formatDate(p0.end), error: '' },
    date2: { start: `${y}-01-01`, end: `${y}-04-01`, error: '' }
  }
  if (p.length > 1) {
    const p1 = p[1]
    pr.twoPeriods = true
    pr.date2.start = formatDate(p1.start)
    pr.date2.end = formatDate(p1.end)
  }
  return pr
}

function mainPeriodLimits (y) {
  const sum = { low: 85, high: 95 }
  if (y === 2020) {
    return {
      start: {
        from: '2019-11-01',
        to: '2020-07-16'
      },
      end: {
        from: '2020-01-31',
        to: '2020-09-01'
      },
      sum: sum
    }
  }

  return {
    start: {
      from: `${y}-01-01`,
      to: `${y}-09-01`
    },

    end: {
      from: `${y}-01-01`,
      to: `${y}-09-01`
    },

    sum
  }
}

function mainObservationPeriodLimits (y) {
  return {
    start: {
      from: `${y}-01-01`,
      to: `${y}-09-01`
    },

    end: {
      from: `${y}-01-01`,
      to: `${y}-09-01`
    }
  }
}

function customPeriodLimits (y) {
  return {
    start: {
      from: `${y}-01-01`,
      to: `${y}-12-31`
    },

    end: {
      from: `${y}-01-02`,
      to: `${y + 1}-01-01`
    }
  }
}

function extractOptionalList (year, list) {
  assert.isNumber(year)
  assert.isArray(list)

  const result = []

  const types = [
    {
      value: {
        title: 'Avez-vous surveillé les sepsis pour ce service ?',
        key: 'seps'
      },
      uts: units[year].neoAndMix
    },
    {
      value: {
        title: 'Avez-vous surveillé les pneumopathies pour ce service ?',
        key: 'pneu'
      },
      uts: units[year].adRea.concat(units[year].pedRea)
    }
  ]

  for (let i in list) {
    const u = list[i]
    let r = null

    for (let i in types) {
      const t = types[i]
      if (t.uts.findIndex(e => e.index === u.unitType) !== -1) {
        r = t.value
        break
      }
    }

    if (r != null) {
      result.push(
        {
          unit: u,
          code: `${u.unitType}.${u.uf}`,
          opt: r
        }
      )
    }
  }
  return result
}

function dbgFillList (vm, list) {
  const gen = {
    default: () => rand.getInt(10, 100),
    adm: () => rand.getInt(150, 350),
    bed: () => rand.getInt(15, 25),
    chi: () => rand.getInt(300, 1000),
    jh: () => rand.getInt(800, 1300),
    jhi: () => rand.getInt(800, 1300),
    ven: () => rand.getInt(800, 2000),
    file: () => rand.getInt(100, 300),
    sea: () => rand.getInt(300, 1000)
  }

  for (let i = 0; i !== list.length; ++i) {
    const u = list[i]

    for (let k in u.denominators) {
      const g = gen[k]
      if (g != null) {
        vm.$set(u.denominators, k, `${g()}`)
        continue
      }

      vm.$set(u.denominators, k, `${gen.default()}`)
    }
  }
}

export default {
  steps,
  versionDiff,
  extractUnitList,
  extractDiscList,
  listDenominators,
  prepareUfList,
  datasetRecap,
  makePeriodSheetsList,
  toServerPeriods,
  extractUfList,
  buildPeriod,
  mainPeriodLimits,
  customPeriodLimits,
  mainObservationPeriodLimits,
  extractOptionalList,
  dbgFillList
}
